<script setup lang="ts">
import { vOnClickOutside } from "@vueuse/components";
import { computed } from "vue";

import { defaultTelePort, type TeleportType } from "@/utils/modal.ts";

type Props = {
  teleport: TeleportType
  title?: string
  // room for a table
  wide?: boolean
};

const props = withDefaults(defineProps<Props>(), {
  teleport: () => defaultTelePort,
  canSubmit: true,
  customHeight: "300",
  buttonText: "Submit",
  width: "100%",
  maxWidth: "300px",
});
const duration = 500;

const emit = defineEmits<{
  (event: "close"): void
}>();

const isOpen = computed(() => {
  return props.teleport.isOpen;
});

const onClose = () => {
  if (props.teleport.isOpen) {
    props.teleport.close();

    setTimeout(() => {
      emit("close");
    }, duration);
  }
};
</script>

<template>
  <Teleport to="#modal">
    <div
      v-on-click-outside="onClose"
      class="side_bar_wrapper transition-all duration-500 overflow-y-auto"
      :class="{
        opened: isOpen,
        closed: !isOpen,
        side_bar_wide: props.wide,
      }"
    >
      <slot name="header" />
      <div
        v-if="!$slots.header"
        class="flex justify-between px-5 pt-3 items-center"
      >
        <slot name="title" />
        <span
          v-if="!$slots.title"
          class="text-mainText font-normal text-[24px]"
        >
          {{ title }}
        </span>
        <feather-icon
          type="x"
          width="25"
          class="cursor-pointer stroke-mainText hover:text-negative transition-all duration-500"
          @click="onClose"
        />
      </div>
      <div class="flex flex-col">
        <div class="flex flex-col items-start gap-4 p-4">
          <slot />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style lang="scss">
.side_bar_wrapper {
  @apply fixed right-0 top-0 h-screen bg-mainBg z-[11] w-[80vw] md:w-[40vw] 2xl:w-[30vw] shadow-lg transition-transform ease-in-out;

  transition-duration: v-bind(duration);
}

.side_bar_wide {
  @apply w-[95vw] md:w-[70vw] 2xl:w-[55vw];
}

.opened {
  @apply transform translate-x-0;
}

.closed {
  @apply transform translate-x-full;
}
</style>
